import React from 'react';
import Select from './Select';
import { CheckboxOption } from './components/input-options';
const CheckboxSelect = ({ components, ...props }) => {
    const temp = {
        ...components,
        Option: CheckboxOption,
    };
    return (React.createElement(Select, Object.assign({ closeMenuOnSelect: false, hideSelectedOptions: false, isMulti: true, components: temp }, props)));
};
export default CheckboxSelect;
//# sourceMappingURL=CheckboxSelect.js.map